import React, { useState, useEffect } from 'react';
import { Script } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';
import LazyLoader from '../../components/LazyLoader';
import { GatsbySeo, ProductJsonLd } from 'gatsby-plugin-next-seo';
import parse, { domToReact, attributesToProps } from 'html-react-parser';
import { Trans, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';

// Materia-UI V5
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import PageLayout from '../../containers/PageLayout';
import ProductHeaderContent from './ProductHeaderContent';
import Comments from './comments';
import { SlickProductCardList } from '../../components/ProductCardList';
import { ProductDescription, DescriptionWrapper, ProductDescriptionDetail } from './styles';
import { DISCOUNT_AMOUNT, PRICE_THRESHOLD } from '../../constants/pricing';

export interface ImageWebp {
  id: string;
  image: {
    gatsbyImageData: any;
  };
}
export interface ShopifyProduct {
  id: string;
  title: string;
  handle: string;
  productType: string;
  description: string;
  descriptionHtml: string;
  shopifyId: string;
  options: Array<{
    shopifyId: string;
    name: string;
    values: string[];
  }>;
  priceRangeV2: {
    minVariantPrice: {
      amount: string;
      currencyCode: string;
    };
    maxVariantPrice: {
      amount: string;
      currencyCode: string;
    };
  };
  variants: Array<{
    id: string;
    title: string;
    price: string;
    availableForSale: boolean;
    shopifyId: string;
    compareAtPrice: number;
    selectedOptions: Array<{
      name: string;
      value: string;
    }>;
    image: {
      gatsbyImageData: any;
    };
  }>;
  images: ImageWebp[];
  thumbnails: ImageWebp[];
}

interface Props {
  data: {
    locales: any;
    shopifyProduct: ShopifyProduct;
  };
  slug: string;
  comments: any;
  relatedProduct: any;
}

const ProductPage: React.FC<Props> = ({ data, slug, comments, relatedProduct, children }) => {
  const { language } = useI18next();
  const getRandomArrayElements = (arr, count) => {
    let shuffled = arr.slice(0),
      i = arr.length,
      min = i - count,
      temp = 0,
      index = 0;
    while (i-- > min) {
      index = Math.floor((i + 1) * Math.random());
      temp = shuffled[index];
      shuffled[index] = shuffled[i];
      shuffled[i] = temp;
    }
    return shuffled.slice(min);
  };
  const [relatedProducts] = useState(getRandomArrayElements(relatedProduct, 4));
  const relatedHandles = [];
  relatedProducts.map(({ node }) => {
    return relatedHandles.push(node.handle);
  });

  const product = data.shopifyProduct;
  const { t } = useTranslation();
  const domToReactOptions = {
    replace: (domNode) => {
      if (domNode && domNode.name === 'li') {
        return (
          <li>
            <Typography variant="body2" component="h2">
              <Trans>{domToReact(domNode.children)}</Trans>
            </Typography>
          </li>
        );
      } else if (domNode && domNode.name === 'img') {
        const props = attributesToProps(domNode.attribs);
        return (
          <Box sx={{ minHeight: '100px' }}>
            <LazyLoader priority={LazyLoader.Priority.LOW}>
              <img loading="lazy" max-width="100%" height="100%" alt="product image" {...props} />
            </LazyLoader>
          </Box>
        );
      }
    },
  };

  const siteUrl = 'https://www.paganidesignwatch.com';
  const openGraphImages = [];
  product.images.map(({ id, image }) => {
    const src = getSrc(image.gatsbyImageData);
    return openGraphImages.push(`${getSrc(image.gatsbyImageData)}`);
  });
  const handleArr = product.handle.split('-');
  const newHandle = handleArr[0] + '-' + handleArr[1] + '-' + handleArr[2] + '-' + handleArr[3];
  const productName = handleArr[0] + ' ' + handleArr[1] + ' ' + handleArr[2] + ' ' + handleArr[3];
  const endDate = new Date();
  endDate.setFullYear(endDate.getFullYear() + 1);

  const names = [
    'Maeve',
    'Isla',
    'Ophelia',
    'Eloise',
    'Cora',
    'Genevieve',
    'Aurelia',
    'Maya',
    'Ivy',
    'Alice',
    'Iris',
    'Amaliya',
    'Nova',
    'Everly',
    'Gianna',
    'Eliana',
    'Paisley',
    'Elena',
    'Willow',
    'Emma',
    'Olivia',
    'Ava',
    'Isabella',
    'Sophia',
    'Charlotte',
    'Mia',
    'Amelia',
    'Harper',
    'Evelyn',
    'Abigail',
    'Emily',
    'Elizabeth',
    'Mila',
    'Ella',
    'Avery',
    'Sofia',
    'Camila',
    'Aria',
    'Scarlett',
    'Victoria',
    'Madison',
    'Luna',
    'Grace',
    'Chloe',
    'Penelope',
    'Layla',
    'Riley',
    'Zoey',
    'Nora',
    'Lily',
    'Eleanor',
    'Hannah',
    'Lillian',
    'Addison',
    'Aubrey',
    'Ellie',
    'Stella',
    'Natalie',
    'Zoe',
    'Leah',
    'Hazel',
    'Violet',
    'Aurora',
    'Savannah',
    'Audrey',
    'Brooklyn',
    'Bella',
    'Claire',
    'Skylar',
    'Genesis',
    'Saint',
    'Baker',
    'Kairo',
    'Watson',
    'Kenzo',
    'Jaxtyn',
    'Kylo',
    'Dakari',
    'KarsynEmma',
    'Olivia',
    'Ava',
    'Isabella',
    'Sophia',
    'Charlotte',
    'Mia',
    'Amelia',
    'Harper',
    'Evelyn',
    'Abigail',
    'Emily',
    'Elizabeth',
    'Mila',
    'Ella',
    'Avery',
    'Sofia',
    'Camila',
    'Aria',
    'Scarlett',
    'Victoria',
    'Madison',
    'Luna',
    'Grace',
    'Chloe',
    'Penelope',
    'Layla',
    'Riley',
    'Zoey',
    'Nora',
    'Lily',
    'Eleanor',
    'Hannah',
    'Lillian',
    'Addison',
    'Aubrey',
    'Ellie',
    'Stella',
    'Natalie',
    'Zoe',
    'Leah',
    'Hazel',
    'Violet',
    'Aurora',
    'Savannah',
    'Audrey',
    'Brooklyn',
    'Bella',
    'Claire',
    'Skylar',
    'Lucy',
    'Paisley',
    'Everly',
    'Anna',
    'Caroline',
    'Nova',
    'Genesis',
    'Emilia',
    'Kennedy',
    'Samantha',
    'Maya',
    'Willow',
    'Kinsley',
    'Naomi',
    'Aaliyah',
    'Elena',
    'Sarah',
    'Ariana',
    'Allison',
    'Gabriella',
    'Alice',
    'Madelyn',
    'Cora',
    'Ruby',
    'Eva',
    'Serenity',
    'Autumn',
    'Adeline',
    'Hailey',
    'Gianna',
    'Valentina',
    'Isla',
    'Eliana',
    'Quinn',
    'Nevaeh',
    'Ivy',
    'Sadie',
    'Piper',
    'Lydia',
    'Alexa',
    'Josephine',
    'Emery',
    'Julia',
    'Delilah',
    'Arianna',
    'Vivian',
    'Kaylee',
    'Sophie',
    'Brielle',
    'Madeline',
  ];
  const reviews = [
    'New watch arrived today. First impressions of Pagani Design Watch are always 100%. Another beauty to enjoy for many years to come.',
    'I am impressed with the Pagani Design Watch. The simple elegant design. The color combination is stylish.',
    'The color scheme looks just as good in person as it did in photographs. The numbers are bold and easy to read without being overwhelming or gaudy.',
    'The timer ring is firm and makes easily audible clicks to set in the dark if needed and the band is very comfortable and breaks in quick. It is a great utility watch with an elegant look.',
    'Really an exquisite time piece. Beautifully designed. Elegant in appearance. Looks great on my arm. I love the pagani design watch.',
    'This is a really stylish and allover great watch! I have three of your watches, they are my best! Thank you for your fast and impeccable service!',
    'This watch is a great accent peice that will comliment any outfit. Its durable and functions great. I eouod highly rexommend this pagani design watch.',
    'Quality, style, astetics and price point , even the top grain leather strap creaks like a well worn Chesterfield when you fit the piece to your wrist.',
    'I haven’t had this watch very long but so far it’s really awesome. It’s my daily watch and I’ve taken it hiking and walking and etc.',
    'Beautiful watch, I love the pagani design watch.',
    'Great quality watches ⌚. It makes me feel more stylish and I like how the watch looks when its reflected from the sun. 🌅',
    'Very rich looking. Love the face and mechanical workings. I have been looking for a replacement watch that I had for a long time. Could never find one similar. Until now.',
    'I truly appreciate the process of placing my order to delivery. My watch arrived in a good timely fashion and I simply love the look the feel and quality of the watch. Might even order a another one..',
    'Beautifully designed luxurious watch. Excellent customer service. Will be buying more.',
    'Amazing quality watch for the price you pay for it great exactly as advertised.',
    'Stylish. Affordable. Commands the attention of people around me. Have already recommended it to my friends.',
    'I love my new watch. Amazing for the price. The quality is beyond superb. Materials are well used, and the craftsmanship is spectacular.',
    'I definitely plan to buy more watches from Pagani Design. Their customer service is the best I’ve ever had. Thank you Pagani Design!',
    'It’s a great watch so comfortable and to nice. I love it',
    'It is just what I wanted and expected! Great costumer service! Thanks:)',
    'Loved the size colour and fit of the watch! Great price for a really nice looking watch!',
    'Excellent watch well made lovely, i love it very good, too deal with Pagani Design team will be buying from them again.',
    'Amazing quality and style! Fits perfect. Our second Pagani Design Watch and would definitely order again in the future. Highly recommend!',
    'Watch is great, looks great and the quality is awesome. Weight isn’t too heavy and I love the design. Would recommend to anyone.',
    'Fantastic looking watch looks even better in real feels great good weight to it arrived quick great price too.',
    'The price point makes it attractive but to be honest I would have paid more for the type of quality Pagani Design provides.',
    'Beautiful watch very happy with quality and workmanship. Seems to keep perfect time.',
    'I enjoy the elegant design on the watch and the cool feel it has when I wear it.',
    'The only thing was it just barely fits my wrist so i ordered the mesh strap. I just hope that fits.',
    'Beautiful watch. Definitely pulls compliments from guys and gals alike. Quick delivery and amazing customer service.',
    'Love it! Its a very good quality watch! Will buy another one soon for a birthday present!',
    'It’s really good watch',
    'Great looks, really like the watch so far! Second purchase Pagani Design and they have been outstanding.',
    'I love the way it looks!',
    'This is my second watch from Pagani Design, I get complements all the time. I’m all ready looking for another.',
    'So elegant, perfect gift for my husband on our anniversary',
    'Just purchased off of a whim and I love the quality and the look of this watch. Great craftsmanship.',
    'This is a great chronograph and it’s quite stunning. This is my third watch from Pagani Design and I am very pleased.',
    'The watch looks great and it seems to be made with good materials. You could actually smell the leather band.',
    'Great looking watch, looks and feels as you’d expect. Not my first Pagani Design watch and won’t be my last.',
    'My expectations were high, and this watch exceeded them. It’s amazing!!',
    'Fantastic looking watch. Comfortable to wear. Build quality seems excellent. Best color watch I have ever found.',
    'Excellent watch, got it after my other one broke. Could not be happier with the quality, and the shipping was very quick too.',
    'Awesome watch , will buy again.',
    'Very cool design. Color seems better in photo than in reality. Best Value and an excellent watch for the price.',
    'Looks great. Works great.',
    'It is a great product!. Fits perfect and looks incredible. It is exactly what I was expecting to receive.',
    'This is my second Pagani Design watch and I love it. It is so versatile, can be formal and casual in appearance. No problems with the mechanics and the price is right.',
    'Love it. quality at a amazing price. Definitely recommend it.',
    'bought this for my boyfriend and it had fast shipping, good packaging and when i opened the box it looked even better then the picture online! happy with this purchase, definitely worth it',
    'Watch arrived today! packed very well, adjusted the band, wore it for several hours, then put into my collection.',
    'I am absolutely loving my watch. Great quality and beautifully designed and crafted.',
    'Exceeded my expectation. The watch is very stylish and looks to be more expensive than it was.',
    'Love the design and color of the watch which is the main reasons for my purchase.',
    'Received my Watch yesterday and from ordering it to delivery I was informed of its progress the hole time. The Watch it’s self is great looking and the strap is of good quality.',
    'This is my second Pagani Design watch. Very stylish and sleek.',
    'I am happy with the purchase made, with the quality of the watch, I would definitely recommend Pagani Design.',
    'Watch looks and feels great to wear. Lots of compliments on the appearance.',
    'I received my watch in a short period of time and in perfect condition. It is a fine looking watch and looks more expensive than it really is.',
    'quality was as expected. Impressed by this watch. The model that I selected goes well with casual or dress clothing.',
    'I’m really happy with the way it looks, like the weight and feel on my wrist! Mesh strap is supple and clasp is very solid feeling.',
    'I bought this watch for my dad and he just loves it.',
    'Just received my new watch today. Looks awesome, quality seems to be good as well.',
    'Beautiful watch! It truly is of high quality, it looks good, it feels good to wear it!',
    'Excellent watch. Looks great in person. I will definitely buy more watches from Pagani Design in the future.',
    'Like the color,face it’s versatile.',
    'Excellent watches, especially for the price! I bought 2 Pagani Design watches and one of the two every day.',
    'I love it! Easy to read only wish it had a stop watch feature.',
    'Great quality, looks great, and best of all feels great.',
    'Love the watch, it looks great and the dual time zones are so helpful for work. International delivery was smooth and problem free.',
    'Stylish and sophisticated looking watch.',
    'Have had numerous queries, when wearing out, as to where I got it from. Will definitely be buying more.',
    'I got this watch for someone as a birthday gift. The person seemed to like it and was very impressed.',
    'It keeps time, and looks good. Solid watch. Paid more for it than I would have liked, but I don’t regret the purchase.',
    'This watch is definitely worth the money. It looks and feels like a more expensive watch. It is very comfortable to wear and is watch face is the perfect size.',
    'It’s was pretty nice tho it would be better if there are more holes for the adjustment of length for the wrist.',
    'I’m truly in love with a wrist watch for the first time...its awesome.',
    'Good looking watch, loving it.',
    'Absolutely love this watch. Great craftsmanship. I plan to back as a new customer!',
    'Nice watch. Good quality. Great service',
    'Smart watches make you service them not other way around. Love the face easy to read esp at night.',
    'The Altitude watch, is very nice. Easy to set date and time. Comfortable on the wrist.',
    'Great clean lines and design. Simplicity at its best. Wear it casually or dress.',
    'Great design, attention to detail, and also great visibility during the night.',
  ];

  useEffect(() => {
    // fire GTM view_item event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'USD',
        value:
          parseFloat(product.variants[0].price) > PRICE_THRESHOLD
            ? parseFloat((parseFloat(product.variants[0].price) - DISCOUNT_AMOUNT).toFixed(2))
            : parseFloat(parseFloat(product.variants[0].price).toFixed(2)),
        items: [
          {
            item_id: `${product.title.split(' ')[2]}`,
            item_name: window.location.pathname,
            language: language,
          },
        ],
      },
    });
  }, []);

  return (
    <PageLayout>
      <Script src={`https://cdn.onesignal.com/sdks/OneSignalSDKWorker.js`} strategy="off-main-thread" />
      <Script src={`https://cdn.onesignal.com/sdks/OneSignalSDK.js`} strategy="off-main-thread" />
      <Script
        strategy="off-main-thread"
        dangerouslySetInnerHTML={{
          __html: `setTimeout(function(){
            window.OneSignal = window.OneSignal || [];
            OneSignal.push(function() {
              OneSignal.init({
                appId: '2a1dd530-0731-4a29-aeb1-570eddcfcba3', 
                allowLocalhostAsSecureOrigin: true
              });
              OneSignal.showSlidedownPrompt();
            });
          }, 30000);`,
        }}
      />
      <Script src="https://static.affiliatly.com/v3/affiliatly.js?affiliatly_code=AF-1037030" strategy="off-main-thread" />
      <ProductJsonLd
        name={`${productName}`}
        sku={`${newHandle}`}
        images={openGraphImages}
        description={product.description}
        brand="PAGANI DESIGN WATCH"
        reviews={[
          {
            author: {
              type: 'Person',
              name: `${getRandomArrayElements(names, 1)}`,
            },
            datePublished: `${new Date()}`,
            reviewBody: `${productName} - ${getRandomArrayElements(reviews, 1)}`,
            name: 'So awesome!!!',
            reviewRating: {
              bestRating: '5',
              ratingValue: '5',
              worstRating: '1',
            },
          },
        ]}
        aggregateRating={{
          ratingValue: '4.9',
          reviewCount: `${Math.floor(Math.random() * 500 + 300)}`,
        }}
        offers={{
          url: `${siteUrl}/${newHandle}`,
          priceCurrency: 'USD',
          price:
            parseFloat(product.priceRangeV2.minVariantPrice.amount) > PRICE_THRESHOLD
              ? `${String(parseFloat(product.priceRangeV2.minVariantPrice.amount) - DISCOUNT_AMOUNT)}`
              : `${String(parseFloat(product.priceRangeV2.minVariantPrice.amount))}`,
          priceValidUntil: `${endDate.toLocaleDateString()}`,
          itemCondition: 'NewCondition',
          availability: 'InStock',
          seller: {
            name: 'Pagani Design Watch Official Store',
          },
        }}
        mpn="925872"
      />

      <GatsbySeo
        title={`${t(product.title)}`}
        description={product.description}
        titleTemplate="%s | Pagani Design Watch Official Store"
        openGraph={{
          type: 'website',
          url: `${siteUrl}/${newHandle}`,
          title: `${t(product.title)}`,
          description: `${product.description}`,
          images: [
            {
              url: `${getSrc(product.images[0].image.gatsbyImageData)}`,
              width: 800,
              height: 800,
              alt: `${productName}`,
            },
          ],
        }}
      />

      <Container disableGutters maxWidth="lg">
        <Grid className="product-container" container spacing={{ xs: 0 }}>
          {/*Product Header*/}
          <Grid item xs={12}>
            <ProductHeaderContent className="product-head" product={product} images={product.images} thumbnails={product.thumbnails} />
          </Grid>
          {/*Product parameters and image show*/}
          <Grid item xs={12}>
            <ProductDescription className="product-detail">
              <DescriptionWrapper>
                <ProductDescriptionDetail>
                  <Box sx={{ minHeight: '100vh' }}>
                    <LazyLoader priority={LazyLoader.Priority.LOW}>{parse(product.descriptionHtml, domToReactOptions)}</LazyLoader>
                  </Box>
                </ProductDescriptionDetail>
                <Box sx={{ minHeight: '400px' }}>
                  <Comments slug={slug} comments={comments.edges} />
                  <Box sx={{ my: '1rem', minHeight: '200px' }}>
                    <LazyLoader priority={LazyLoader.Priority.LOW}>
                      <Typography variant="subtitle2" component="h2" sx={{ textAlign: 'center' }}>
                        <Trans>Customers who viewed this item also viewed</Trans>
                      </Typography>
                      <SlickProductCardList className="slick" products={relatedProducts} handles={relatedHandles} />
                    </LazyLoader>
                  </Box>
                </Box>
              </DescriptionWrapper>
            </ProductDescription>
            <div>{children}</div>
          </Grid>
        </Grid>
      </Container>
    </PageLayout>
  );
};

export default ProductPage;
